import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFileVideo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 19,
	viewBox: "0 0 19 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.5625 15.2539C3.2625 15.2539 3 15.1414 2.775 14.9164C2.55 14.6914 2.4375 14.4289 2.4375 14.1289V4.37891C2.4375 4.07891 2.55 3.81641 2.775 3.59141C3 3.36641 3.2625 3.25391 3.5625 3.25391H13.3125C13.6125 3.25391 13.875 3.36641 14.1 3.59141C14.325 3.81641 14.4375 4.07891 14.4375 4.37891V8.41016L17.4375 5.41016V13.0977L14.4375 10.0977V14.1289C14.4375 14.4289 14.325 14.6914 14.1 14.9164C13.875 15.1414 13.6125 15.2539 13.3125 15.2539H3.5625ZM3.5625 14.1289H13.3125V4.37891H3.5625V14.1289Z",
		fill: "#1D1D1D"
	})
});
export default SvgFileVideo;
